import styled from 'styled-components';

export const PrintSection = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  opacity: 0;
  .container {
    max-width: 100%;
    background-color: #fff;
  }
  .logos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding: 0 15px;
    .empty {
      display: none;
    }
    img {
      width: 100%;
    }
    .logo-top {
      width: 70px;
    }
    .partner {
      width: 100px;
    }
  }
  .table-container {
    padding: 30px 15px;
    background-color: #fff;

    .table-title .print-title {
      display: block;
    }

    h2 {
      max-width: 770px;
      margin: 0 auto 50px auto;
      font-family: var(--bllink-font-headers);
      font-size: 42px;
      line-height: 62px;
      text-align: center;
      color: #373647;
    }
    .building-title {
      display: block;
      color: var(--bllink-purple);
    }
  }
  #table {
    max-height: unset !important;
    height: auto !important;
    th, td {
      padding: 20px 5px !important;
    }
    th:nth-child(1), th:nth-child(2) {
      max-width: 70px;
    }
  }

  .actions-bar, .pdff, .show-all {
    display: none;
  }

  .hidden {
    display: block !important;
  }

  .row.new-row-set2_2 {
    min-height: 104px;
    height: auto !important;
    padding-bottom: 20px;
  }

  .hidden-except-print {
    display: block;
  }
`;
